import VChartsLoader from './lib/vcharts_loader.js';
import { intersectionObserverLazyLoad } from './global';

class HosterAlternativesPage {
  constructor() {
    this.vchartsLoader = new VChartsLoader();
  }

  init() {
    this.vchartsLoader.init();
    intersectionObserverLazyLoad('lazy-chart', '300px', (canvas) => this.loadScatterChart($(canvas)));
    this.initIndexProviderSelection();
    this.initIndexPrioritySelection();
  }

  initIndexProviderSelection() {
    const otherProviderSelect = $('.alternatives-other-provider-select');
    if (otherProviderSelect.length === 0) return;

    $('.alternatives-provider-input').on('change', function() {
      if (this.checked) otherProviderSelect.val('');
    });
    otherProviderSelect.on('change', function() {
      if (this.value) $('.alternatives-provider-input').prop('checked', false);
    });
  }

  initIndexPrioritySelection() {
    const priorityInputs = $('.alternative-priority-input');
    if (priorityInputs.length === 0) return;

    const setPriorityOption = function(input) {
      const priorityOptions = priorityInputs.closest('.alternative-priority-option');
      priorityOptions.removeClass('btn-primary').addClass('btn-outline-primary');
      $(input).closest('.alternative-priority-option').removeClass('btn-outline-primary').addClass('btn-primary');
    };
    const serverSelectedInput = priorityInputs.filter('[data-server-selected="true"]');
    if (serverSelectedInput.length > 0) {
      priorityInputs.prop('checked', false);
      serverSelectedInput.prop('checked', true);
      setPriorityOption(serverSelectedInput);
    }

    priorityInputs.on('change', function() {
      setPriorityOption(this);
    });
  }

  loadScatterChart(canvas) {
    const ctx = canvas.get(0).getContext('2d');
    $.ajax({
      type: 'GET',
      url: canvas.data('chart-url'),
      dataType: 'json',
      success: (data) => this.vchartsLoader.vpsb_scatter_chart(ctx, data, canvas.attr('id'))
    });
  }
}

$(document).on('turbo:load', function() {
  if ($('body.hoster_alternatives.alternatives, body.hoster_alternatives.index').length === 0) return;
  new HosterAlternativesPage().init();
});
